const API_BASE = process.env.REACT_APP_API_URL || '/api';

const request = async (path, options = {}) => {
  const headers = { 'Content-Type': 'application/json', ...options.headers };

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const body = await response.text();
    let message = response.statusText;
    if (body) {
      try {
        message = JSON.parse(body).detail || message;
      } catch {
        // Not JSON — fall back to statusText.
      }
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const getServices = () => request('/services');

export const getGalleryItems = () => request('/gallery');

export const getGalleryItem = (id) => request(`/gallery/${id}`);

export const submitBooking = (formData) =>
  request('/bookings', { method: 'POST', body: JSON.stringify(formData) });

export const getBookingAvailability = (days = 90) =>
  request(`/bookings/availability?days=${days}`);
